import { useRouter } from 'next/router';
import { TrackDocumentsEvent } from '$analytics/useTrackAnalytics/domains/documents/events';
import { useTrackDocsAnalytics } from '$analytics/useTrackAnalytics/domains/documents/useTrackDocsAnalytics';

export const useTrackIfLeavingSendNowPage = () => {
  const { pathname } = useRouter();
  const trackEvent = useTrackDocsAnalytics();

  const trackIfLeavingSendNowPage = () => {
    if (pathname.includes('send-now')) {
      trackEvent(TrackDocumentsEvent.PrepareEnvelopeExit, {
        eventTarget: 'navigation',
        result: null,
      });
    }
  };

  return trackIfLeavingSendNowPage;
};
